export const ARTICLES_PER_PAGE = 6;

export const ARTICLES_FILTER_TAG = "tag";
